import HeaderWithSearch from './header-with-search';
import ProductsOverview from './products-overview';
import ProductDownloadWizardWrapper from './product-download-wizard-wrapper';
import ProjectionCalculator from './projection-calculator';
import ConfiguratorIframe from './configurator-iframe';


export default (di) => {
	di
		.setType({type: HeaderWithSearch, name: 'HeaderWithSearch', parent: 'CollapsableHeader'})
		.setType({type: ProductsOverview, name: 'ProductsOverview', parent: 'FilterableList'})
		.setType({type: ProductDownloadWizardWrapper, name: 'ProductDownloadWizardWrapper', parent: 'PageComponent'})
		.setType({type: ProjectionCalculator, name: 'ProjectionCalculator', parent: 'PageComponent'})
		.setType({type: ConfiguratorIframe, name: 'ConfiguratorIframe', parent: 'PageComponent'})
	;
};
